import processPostsListAJAX from '../util/processPostsListAJAX';

export default {
    multiSelectBoxes() {
        //   Auto-submit form on input change and AJAX load results
        $(
            '.visc-query-filter__form.visc-query-filter__form--ajax select.auto-submit, .visc-query-filter__form.visc-query-filter__form--ajax input[type="checkbox"], .visc-query-filter__form.visc-query-filter__form--ajax input[type="radio"]'
        ).on('change', function (e) {
            // Prevent form from submitting normally
            e.preventDefault();
            let $form = $(this).closest('form');
            let $formID = $form.attr('id');
            // Get the form data
            let formData = $form.serialize();
            // Get the form action
            let formAction = $form.attr('action');

            let url = formAction + '?' + formData;
            // Get new results using AJAX
            processPostsListAJAX(url, $formID);
        });

        let filterSelectInputs = document.querySelectorAll(
            '.visc-query-filter__select'
        );
        if (filterSelectInputs.length > 0) {
            filterSelectInputs.forEach(function (input) {
                if (!input.classList.contains('input--hidden')) {
                    if (input.multiple) {
                        let selector = '.visc-query-filter__select#' + input.id;
                        // eslint-disable-next-line no-unused-vars, no-undef
                        let selectBox = new vanillaSelectBox(selector, {
                            placeHolder: input.dataset.placeholder,
                            disableSelectAll: true,
                            maxWidth: 300,
                        });
                    }
                }
            });
        }
    },
    init() {
        // JavaScript to be fired on the home page
        this.multiSelectBoxes();
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/vehicles.js